/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneReelSymbol} from "../../symbols/TombstoneReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WinNumberText} from "../individual/TombstoneIndividualWPView";

export class TombstoneInitialWPView extends BaseView {

    private _layer:ScalableLayer;
    private _sparkContainer:PIXI.Container;
    private _smokeContainer:PIXI.Container;
    private _winSparksPool:TimelineSprite[] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    protected initAnimations():void {
        this._sparkContainer = new PIXI.Container();
        this._smokeContainer = new PIXI.Container();

        this._layer.addChild(this._sparkContainer);
        this._layer.addChild(this._smokeContainer);
    }

    public addWinNumberToTimeline(timeline:Timeline, startTime:number, position:[number, number], symbol:TombstoneReelSymbol, betWayWinData:IBetWayWinData):void {
        symbol.shouldPlayWinText = {
            position : position,
            betWayWinData : betWayWinData
        };
        timeline.add(() => {
            this.playWinNumberOnPosition(position, symbol, betWayWinData)
        }, startTime);
    }

    public addWinSparkToTimeline(timeline:Timeline, startTime:number, position:[number, number]):void {
        const spark:TimelineSprite = this.getWinSpark();
        spark.position.set(position[0], position[1]);
        this._sparkContainer.addChild(spark);

        const overlayTimeline:TimelineLite = new TimelineLite({paused : true});

        overlayTimeline.add(spark.getAnimationAutoShowHide());
        overlayTimeline.add(() => {
            this._sparkContainer.removeChild(spark);
            this._winSparksPool.push(spark);
        });
        timeline.add(() => overlayTimeline.play(), startTime);
    }

    private getWinSpark():TimelineSprite {
        if(this._winSparksPool.length === 0) {
            const spark:TimelineSprite = new TimelineSprite(GameResources.getTextures("sparkSmoke"));
            spark.blendMode = PIXI.BLEND_MODES.SCREEN;
            spark.anchor.set(0.5, 0.5);
            spark.hide();

            return spark;
        }

        return this._winSparksPool.pop()!;
    }

    public playWinNumberOnPosition(position:[number, number], symbol:TombstoneReelSymbol, betWayWinData:IBetWayWinData):void {
        const winText = new WinNumberText(betWayWinData.amount, betWayWinData.multiplier, betWayWinData.numberOfCombinations);
        winText.position.set(position[0], position[1]);
        const winTextTl = new TimelineLite();
        winTextTl.add(() => {
            symbol.winTextPlayed = true;
            StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.MULTIPLIER.name).addChild(winText);
        });
        winTextTl.add([
            TweenLite.to(winText, 1, {y : position[1] - 100}),
            TweenLite.to(winText, 0.8, {alpha : 0, delay : 0.2})
        ], `+=0.3`);
        winTextTl.add(() => {
            winText.parent.removeChild(winText);
            winText.destroy();
        });
    }

    public addWildHoleSmoke(timeline:Timeline, startTime:number, position:[number, number]):void {
        const smoke:TimelineSprite = new TimelineSprite(GameResources.getTextures("holeSmoke"));
        smoke.blendMode = PIXI.BLEND_MODES.SCREEN;
        smoke.anchor.set(0.5, 1);
        smoke.scale.set(2, 2);
        smoke.position.set(position[0], position[1] + 14);
        smoke.hide();
        this._smokeContainer.addChild(smoke);

        const smokeTimeline:TimelineLite = new TimelineLite({paused : true});
        smokeTimeline.add(smoke.getAnimationAutoShowHide());
        smokeTimeline.add(() => this._smokeContainer.removeChild(smoke));

        timeline.add(() => smokeTimeline.play(), startTime);
    }

    public stopWinPresentation():void {
        // let all the animation go itself.
    }
}